<div class="wrapper d-flex align-items-stretch">
  <nav id="sidebar" class="active">
    <h1>
      <a [routerLink]="['/projects']" class="logo"><img style="width: 40%;" src="../../assets/img/brand/ScriblrIcon.png"
          alt="InScribe" /></a>
    </h1>
    <ul class="list-unstyled components mb-5">
      <li class="active">
        <a [routerLink]="['/projects']"><span class="fas fa-sticky-note text-info"></span> Project</a>
      </li>
      <li>
        <a (click)="showAreas('capture')"><span class="fas fa-file-import text-info"></span> Capture</a>
      </li>
      <li style="display: none;">
        <a (click)="showAreas('images')"><span class="fas fa-images text-green"></span> Images</a>
      </li>
      <li style="display: none;">
        <a (click)="showAreas('videos')"><span class="fas fa-video text-orange"></span> Video</a>
      </li>
      <li style="display: none;">
        <a (click)="showAreas('audio')"><span class="fas fa-volume-up text-purple"></span> Audio</a>
      </li>
      <li>
        <a (click)="showAreas('links')"><span class="fas fa-bookmark text-red"></span> Links</a>
      </li>
      <li style="display: none;">
        <a (click)="showAreas('documents')"><span class="fas fa-file text-gray"></span> Files</a>
      </li>
    </ul>

    <div class="footer">
      <p>
        Copyright &copy;
        <script>
          document.write(new Date().getFullYear());
        </script>
        All rights reserved | This template is made with
        <i class="icon-heart" aria-hidden="true"></i> by
        <a href="https://colorlib.com" target="_blank">Colorlib.com</a>
      </p>
    </div>
  </nav>
  <div class="content" style="width: 100%;">
    <div class="row">
      <div class="col-1" *ngIf="
          !(
            viewers.pageViewer ||
            viewers.imageViewer ||
            viewers.uploadViewer ||
            viewers.imageCarousel ||
            viewers.videoCarousel ||
            viewers.linkCarousel ||
            viewers.audioCarousel ||
            viewers.documentsCarousel
          ) ||
          isMobileResolution ||
          !viewers.captureContainer ||
          !viewers.writingCanvas
        "></div>
      <div id="editorWorkspace" *ngIf="viewers.writingCanvas" [ngClass]="
          (viewers.pageViewer ||
            viewers.imageViewer ||
            viewers.uploadViewer ||
            viewers.imageCarousel ||
            viewers.videoCarousel ||
            viewers.linkCarousel ||
            viewers.audioCarousel ||
            viewers.documentsCarousel) &&
          viewers.captureContainer
            ? isMobileResolution
              ? 'col-xs-10 col-sm-10 col-md-10 col-lg-7 col-xl-7 order-lg-2 order-xl-2'
              : 'col-xs-10 col-sm-10 col-md-10 col-lg-7 col-xl-7 order-lg-2 order-xl-2'
            : 'col-10'
        ">
        <nav class="navbar sticky-top justify-content-between" style="background: transparent;">
          <span>
            <span class="action-messages">{{ noteWords }} Words</span>
            <span class="action-messages text-muted">{{ savedMessage }}</span>
          </span>
          <span>
            <a class="action-button float-right" (click)="signout()" tooltip="Sign out" placement="left"><i class="fas fa-sign-out-alt"></i></a>
            <!-- User Profile -->
            <a class="action-button float-right" (click)="saveNote()" tooltip="Save content" placement="left"><i class="fas fa-save"></i></a>
            <!-- Save -->

            <!-- Information -->
            <a class="action-button float-right" *ngIf="viewers.captureContainer" (click)="toggleCaptureContainer()" tooltip="Focused mode" placement="bottom"><i
                class="fas fa-expand"></i></a>

            <!-- Expand -->
            <a class="action-button float-right" *ngIf="!viewers.captureContainer" (click)="toggleCaptureContainer()" tooltip="Reference mode" placement="bottom"><i
                class="fas fa-compress"></i></a>

            <!-- Compress -->
            {{ timerValue }}
            <a #start class="action-button float-right" (click)="startTimer()" *ngIf="!timerRunning" tooltip="Start timer" placement="bottom"><i class="fas fa-stopwatch"></i>
            </a>
            <a #start class="action-button float-right" (click)="stopTimer()" *ngIf="timerRunning" tooltip="Stop timer" placement="bottom">
              <i class="fas fa-stop"></i>
            </a>
          </span>
        </nav>

        <div class="row header-bar sticky-top" style="top: 70px;">
          <div class="col title-container">
            <h1 *ngIf="titleTextMode" name="title-text">
              {{ note.title }}
              <button (click)="titleTextMode = !titleTextMode"
                class="btn rounded-circle btn-icon-only btn-2 btn-outline-secondary" type="button"
                style="margin-top: -0.1rem;"
                tooltip="Change title" placement="bottom">
                <span class="btn-inner--icon">
                  <i class="fa fa-pencil-alt" aria-hidden="true"></i>
                </span>
              </button>
              <!-- Title Edit Button -->
            </h1>
            <h1 *ngIf="!titleTextMode">
              <div class="input-group input-group-merge mb-3" style="width: 95%;">
                <input class="article-title form-control form-control-alternative" type="text" placeholder="Enter title"
                  name="title" [(ngModel)]="note.title" />
                <div class="input-group-append">
                  <button (click)="saveNote()" class="btn btn-icon-only btn-outline-secondary" type="button">
                    <span class="btn-inner--icon">
                      <i class="ni ni-check-bold" aria-hidden="true"></i>
                    </span>
                  </button>
                </div>
              </div>
            </h1>
          </div>
        </div>
        <!-- Title -->
        <div class="row">
          <div class="col notes">
            <quill-editor customToolbarPosition="bottom" [modules]="quillModule" [(ngModel)]="note.notes"
              (onContentChanged)="editorContentChanged($event)" (keyup)="splitNoteToWords()"></quill-editor>
          </div>
        </div>
      </div>
      <!-- Compose -->
      <div id="contentWorkspace" [ngClass]="
          !viewers.writingCanvas
            ? 'col-10'
            : 'col-xs-12 col-sm-12 col-md-12 col-lg-5 col-xl-5'
        " *ngIf="
          (viewers.pageViewer ||
            viewers.imageViewer ||
            viewers.uploadViewer ||
            viewers.imageCarousel ||
            viewers.videoCarousel ||
            viewers.linkCarousel ||
            viewers.audioCarousel ||
            viewers.documentsCarousel) &&
          viewers.captureContainer
        ">
        <div class="row">
          <div class="col float-left" style="padding: 1rem; padding-right: 1rem;">
            <!-- Expand -->
            <button *ngIf="viewers.writingCanvas"
              class="btn rounded-circle btn-icon-only btn-2 btn-outline-secondary float-right" type="button"
              style="margin-top: -0.1rem;" (click)="viewers.writingCanvas = !viewers.writingCanvas">
              <span class="btn-inner--icon"><i class="fas fa-expand" aria-hidden="true"></i></span>
            </button>
            <!-- Expand -->
            <button *ngIf="!viewers.writingCanvas"
              class="btn rounded-circle btn-icon-only btn-2 btn-outline-secondary float-right" type="button"
              style="margin-top: -0.1rem;" (click)="viewers.writingCanvas = !viewers.writingCanvas">
              <span class="btn-inner--icon"><i class="fas fa-compress" aria-hidden="true"></i></span>
            </button>
            <!-- Shrink -->
            <!-- Notes -->
          </div>
        </div>
        <!-- Viewers Actions Bar -->

        <div class="row">
          <div class="col viewer" *ngIf="
              viewers.pageViewer ||
              viewers.imageViewer ||
              viewers.uploadViewer ||
              viewers.imageCarousel ||
              viewers.videoCarousel ||
              viewers.linkCarousel ||
              viewers.audioCarousel ||
              viewers.documentsCarousel
            ">
            <div class="row">
              <div class="col">
                <accordion style="margin-top: 1rem !important; margin-left: 1rem !important;" [isAnimated]="true" *ngIf="
                    viewers.pageViewer ||
                    viewers.imageViewer ||
                    viewers.uploadViewer ||
                    viewers.imageCarousel ||
                    viewers.videoCarousel ||
                    viewers.linkCarousel ||
                    viewers.audioCarousel ||
                    viewers.documentsCarousel
                  ">

                  <accordion-group *ngIf="viewers.imageViewer" [isOpen]="viewers.imageViewer">
                    <button class="btn btn-link btn-block clearfix" accordion-heading type="button">
                      <div class="pull-left float-left">Image View</div>
                      <span class="float-right pull-right">
                        <a (click)="viewers.imageViewer = !viewers.imageViewer" *ngIf="
                            viewers.pageViewer ||
                            viewers.uploadViewer ||
                            viewers.imageCarousel ||
                            viewers.videoCarousel ||
                            viewers.linkCarousel ||
                            viewers.audioCarousel ||
                            viewers.documentsCarousel
                          "><i class="fa fa-times"></i></a>

                        <!-- Close -->
                      </span>
                    </button>
                    <div class="container" *ngIf="showPreview">
                      <h1>
                        <span>Preview</span>
                      </h1>
                      <img [src]="previewImageUrl" alt="image slide" style="
                          display: block;
                          width: 100%;
                          border-radius: calc(0.5rem - 1px);
                        " (click)="showImage(item)" />
                    </div>
                  </accordion-group>
                  <!-- Image Viewer -->
                  <accordion-group id="linkCaptureBox" [isOpen]="
                      viewers.uploadViewer &&
                      !viewers.pageViewer &&
                      !viewers.imageViewer
                    " *ngIf="viewers.uploadViewer">
                    <button class="btn btn-link btn-block clearfix" accordion-heading type="button">
                      <div class="pull-left float-left">Capture Link</div>
                      <span class="float-right pull-right">
                        <a (click)="viewers.uploadViewer = !viewers.uploadViewer" *ngIf="
                            viewers.pageViewer ||
                            viewers.imageViewer ||
                            viewers.imageCarousel ||
                            viewers.videoCarousel ||
                            viewers.linkCarousel ||
                            viewers.audioCarousel ||
                            viewers.documentsCarousel
                          "><i class="fa fa-times"></i></a>

                        <!-- Close -->
                      </span>
                    </button>
                    <div class="row">
                      <div class="col">
                        <form>
                          <div class="input-group mb-3">
                            <input type="text" placeholder="Paste/Type URL" name="search" [(ngModel)]="newURL"
                              class="form-control" />
                            <div class="input-group-append">
                              <button *ngIf="linkCaptureProgress == 0" class="btn btn-success" type="button"
                                [disabled]="!newURL || newURL ==''" (click)="loadNewURL(newURL)">
                                Go
                              </button>
                              <button class="btn btn-outline-secondary" type="button" disabled
                                *ngIf="linkCaptureProgress > 0">
                                <mat-spinner diameter="25" color="success"></mat-spinner>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                <span class="sr-only">Loading...</span>
                              </button>
                              <span class="sr-only">Loading...</span>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <!-- Link Placeholder -->
                  </accordion-group>
                  <!-- Link Capture -->
                  <accordion-group [isOpen]="
                      viewers.uploadViewer &&
                      !viewers.pageViewer &&
                      !viewers.imageViewer
                    " *ngIf="viewers.uploadViewer" style="display:none;">
                    <button class="btn btn-link btn-block clearfix" accordion-heading type="button">
                      <div class="pull-left float-left">Attach Files</div>
                      <span class="float-right pull-right">
                        <a (click)="viewers.uploadViewer = !viewers.uploadViewer" *ngIf="
                            viewers.pageViewer ||
                            viewers.imageViewer ||
                            viewers.imageCarousel ||
                            viewers.videoCarousel ||
                            viewers.linkCarousel ||
                            viewers.audioCarousel ||
                            viewers.documentsCarousel
                          "><i class="fa fa-times"></i></a>

                        <!-- Close -->
                      </span>
                    </button>
                    <div class="row">
                      <div class="col">
                        <ngx-dropzone (change)="onSelect($event)">
                          <ngx-dropzone-label>Drop it, baby!</ngx-dropzone-label>
                          <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files"
                            [file]="f" [removable]="true" (removed)="onRemove(f)">
                            <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                          </ngx-dropzone-image-preview>
                        </ngx-dropzone>
                        <button type="button" class="btn btn-primary" (click)="uploadFiles()">
                          Upload
                        </button>
                      </div>
                    </div>

                  </accordion-group>
                  <!-- File Drop Zone -->
                  <!-- Image Capture -->
                  <accordion-group [isOpen]="
                      note &&
                      note.linksArray&&
                      note.linksArray.length > 0 &&
                      viewers.linkCarousel
                    " *ngIf="
                      note &&
                      note.linksArray &&
                      note.linksArray.length > 0 &&
                      viewers.linkCarousel
                    ">
                    <button class="btn btn-link btn-block clearfix" accordion-heading type="button">
                      <div class="pull-left float-left" id="linkViewerBox">
                        Links <span>({{ note.linksArray.length }})</span>
                      </div>
                      <span class="float-right pull-right">
                        <a (click)="viewers.linkCarousel = !viewers.linkCarousel" *ngIf="
                            viewers.pageViewer ||
                            viewers.imageViewer ||
                            viewers.uploadViewer ||
                            viewers.videoCarousel ||
                            viewers.linkCarousel ||
                            viewers.audioCarousel ||
                            viewers.documentsCarousel
                          "><i class="fa fa-times"></i></a>

                        <!-- Close -->
                      </span>
                    </button>
                    <div class="row mx-0" *ngIf="viewers.linkCarousel">
                      <div class="col">
                        <app-link-carousel [items]="note.linksArray" [unlinkedItems]="unlinkedLinksArray"
                          (displayContent)="displayUrlContent($event)" (deleteItem)="deleteItem($event)"
                          *ngIf="note && note.linksArray"></app-link-carousel>
                      </div>
                    </div>
                  </accordion-group>
                  <!-- Link Carousel -->
                  <accordion-group [isOpen]="viewers.pageViewer" *ngIf="viewers.pageViewer">
                    <button class="btn btn-link btn-block clearfix" accordion-heading type="button">
                      <div class="pull-left float-left">Page Content</div>
                      <span class="float-right pull-right" style="padding-left: 16px;">
                        <a (click)="gallery.show()" tooltip="Expand" placement="bottom"><i class="far fa-window-maximize"></i> </a>
                      </span>
                      <span class="float-right pull-right">
                        <a (click)="
                            viewers.pageViewer = !viewers.pageViewer;
                            viewers.linkCarousel = !viewers.linkCarousel
                          "><i class="fa fa-times"></i></a>

                        <!-- Close -->
                      </span>
                    </button>
                    <p [innerHtml]="clearTextContentForUrl"></p>
                    <!-- Link -->
                  </accordion-group>
                  <!-- Page Viewer -->
                  <accordion-group [isOpen]="
                      note &&
                      note.imagesArray &&
                      note.imagesArray.length > 0 &&
                      viewers.imageCarousel
                    " *ngIf="
                      note &&
                      note.imagesArray &&
                      note.imagesArray.length > 0 &&
                      viewers.imageCarousel
                    ">
                    <button class="btn btn-link btn-block clearfix" accordion-heading type="button">
                      <div class="pull-left float-left">
                        Images <span>({{ note.imagesArray.length }})</span>
                      </div>
                      <span class="float-right pull-right">
                        <a (click)="viewers.imageCarousel = !viewers.imageCarousel" *ngIf="
                            viewers.pageViewer ||
                            viewers.imageViewer ||
                            viewers.uploadViewer ||
                            viewers.videoCarousel ||
                            viewers.linkCarousel ||
                            viewers.audioCarousel ||
                            viewers.documentsCarousel
                          "><i class="fa fa-times"></i></a>

                        <!-- Close -->
                      </span>
                    </button>
                    <div class="row">
                      <div class="col">
                        <app-image-carousel [items]="note.imagesArray" (enlargeImage)="showEnlargedImage($event)"
                          (deleteItem)="deleteImage($event)" *ngIf="note && note.imagesArray"></app-image-carousel>
                      </div>
                    </div>
                    <!-- Image Carousel -->
                  </accordion-group>
                  <!-- Image Carousel -->
                  <accordion-group [isOpen]="
                      note &&
                      note.videos &&
                      note.videosArray.length > 0 &&
                      viewers.videoCarousel
                    " *ngIf="
                      note &&
                      note.videos &&
                      note.videosArray.length > 0 &&
                      viewers.videoCarousel
                    ">
                    <button class="btn btn-link btn-block clearfix" accordion-heading type="button">
                      <div class="pull-left float-left">
                        Videos <span>({{ note.videosArray.length }})</span>
                      </div>
                      <span class="float-right pull-right">
                        <a (click)="viewers.videoCarousel = !viewers.videoCarousel" *ngIf="
                            viewers.pageViewer ||
                            viewers.imageViewer ||
                            viewers.uploadViewer ||
                            viewers.imageCarousel ||
                            viewers.linkCarousel ||
                            viewers.audioCarousel ||
                            viewers.documentsCarousel
                          "><i class="fa fa-times"></i></a>

                        <!-- Close -->
                      </span>
                    </button>
                    <div class="row">
                      <div class="col">
                        <app-video-carousel [items]="note.videosArray" (deleteItem)="deleteVideo($event)"
                          *ngIf="note && note.videos"></app-video-carousel>
                      </div>
                    </div>
                    <!-- Videos -->
                  </accordion-group>
                  <!-- Video Carousel -->
                  <accordion-group [isOpen]="
                      note &&
                      note.audiosArray &&
                      note.audiosArray.length > 0 &&
                      viewers.audioCarousel
                    " *ngIf="
                      note &&
                      note.audiosArray &&
                      note.audiosArray.length > 0 &&
                      viewers.audioCarousel
                    ">
                    <button class="btn btn-link btn-block clearfix" accordion-heading type="button">
                      <div class="pull-left float-left">
                        Audio <span>({{ note.audiosArray.length }})</span>
                      </div>
                      <span class="float-right pull-right">
                        <a (click)="viewers.audioCarousel = !viewers.audioCarousel" *ngIf="
                            viewers.pageViewer ||
                            viewers.imageViewer ||
                            viewers.uploadViewer ||
                            viewers.imageCarousel ||
                            viewers.videoCarousel ||
                            viewers.linkCarousel ||
                            viewers.documentsCarousel
                          "><i class="fa fa-times"></i></a>

                        <!-- Close -->
                      </span>
                    </button>
                    <div class="row">
                      <div class="col">
                        <app-audio-carousel [items]="note.audiosArray" (deleteItem)="deleteAudio($event)"
                          *ngIf="note && note.audios"></app-audio-carousel>
                      </div>
                    </div>
                    <!-- Audio -->
                  </accordion-group>
                  <!-- Audio Carousel -->
                  <accordion-group [isOpen]="
                      note &&
                      note.documents &&
                      note.documentsArray &&
                      note.documentsArray.length > 0 &&
                      viewers.documentsCarousel
                    " *ngIf="
                      note &&
                      note.documents &&
                      note.documentsArray &&
                      note.documentsArray.length > 0 &&
                      viewers.documentsCarousel
                    ">
                    <button class="btn btn-link btn-block clearfix" accordion-heading type="button">
                      <div class="pull-left float-left">
                        Documents <span>({{ note.documentsArray.length }})</span>
                      </div>
                      <span class="float-right pull-right">
                        <a (click)="
                            viewers.documentsCarousel = !viewers.documentsCarousel
                          " *ngIf="
                            viewers.pageViewer ||
                            viewers.imageViewer ||
                            viewers.uploadViewer ||
                            viewers.imageCarousel ||
                            viewers.videoCarousel ||
                            viewers.linkCarousel ||
                            viewers.audioCarousel
                          "><i class="fa fa-times"></i></a>

                        <!-- Close -->
                      </span>
                    </button>
                    <div class="row">
                      <div class="col">
                        <app-documents-carousel [items]="note.documentsArray" (displayContent)="displayDocument($event)"
                          (deleteItem)="deleteDocument($event)" *ngIf="note && note.documentsArray">
                        </app-documents-carousel>
                      </div>
                    </div>
                    <!-- Documents -->
                  </accordion-group>
                  <!-- Documents Carousel -->
                </accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Capture & Compile -->
    </div>
  </div>
  <!-- Timer Modal -->
  <ng-template #template class="modal-sm">
    <div class="modal-header">
      <h4 class="modal-title pull-left">Track Time</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body text-center">
      <h3>Time Spent So Far</h3>
      <h3>{{ timerValue }}</h3>
      <div style="padding: 10px;">
        <button #start class="btn rounded-circle btn-icon-only btn-2 btn-outline-secondary" (click)="startTimer()"
          type="button" *ngIf="!timerRunning">
          <span class="btn-inner--icon text-info"><i class="fas fa-play"></i></span>
        </button>
        <!-- <button #start class="btn btn-icon btn-2 btn-primary" (click)="restartTimer()" type="button">
          <span class="btn-inner--icon"><i class="fas fa-pause"></i></span>
        </button> -->
        <button #start class="btn rounded-circle btn-icon-only btn-2 btn-outline-secondary" (click)="stopTimer()"
          type="button" *ngIf="timerRunning">
          <span class="btn-inner--icon text-red"><i class="fas fa-stop"></i></span>
        </button>
      </div>
    </div>
  </ng-template>
  <!-- Timer Modal -->

  <!-- Page viewer Overlay -->
  <!--  -->
  <div class="modal fade" bsModal
  #gallery="bs-modal" tabindex="-1" role="dialog" aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content" style="overflow-y: scroll;">
        <div class="modal-header">
          <!-- <h4 id="dialog-sizes-name1" class="modal-title pull-left">Large modal</h4> -->
          <!--  -->
          <button type="button" class="close pull-right" aria-label="Close" (click)="gallery.hide()" tooltip="Close" placement="left">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="container h-100">
            <p [innerHtml]="clearTextContentForUrl"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Page Viewer Overlay -->
</div>